import { forwardRef } from 'react';
import { Loader2 } from 'lucide-react';
import { cx } from './cx';
import styles from './Button.module.css';

/**
 * @param {'primary'|'secondary'|'ghost'|'danger'} variant
 * @param {'sm'|'md'|'lg'} size
 * @param {import('react').ComponentType} icon Icon links (lucide-react)
 */
export const Button = forwardRef(function Button(
  { variant = 'primary', size = 'md', loading = false, icon: Icon, iconRight: IconRight, fullWidth = false,
    type = 'button', disabled, className, children, ...props },
  ref
) {
  return (
    <button
      ref={ref}
      type={type}
      className={cx(styles.button, styles[variant], styles[size], fullWidth && styles.full, className)}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...props}
    >
      {loading ? <Loader2 className={styles.spin} aria-hidden /> : Icon && <Icon aria-hidden />}
      {children != null && <span className={styles.label}>{children}</span>}
      {IconRight && !loading && <IconRight aria-hidden />}
    </button>
  );
});

/** Schaltfläche nur mit Symbol – `label` ist Pflicht (Screenreader und Tooltip) */
export const IconButton = forwardRef(function IconButton(
  { icon: Icon, label, variant = 'ghost', size = 'md', type = 'button', className, ...props },
  ref
) {
  return (
    <button
      ref={ref}
      type={type}
      aria-label={label}
      title={label}
      className={cx(styles.button, styles.iconOnly, styles[variant], styles[size], className)}
      {...props}
    >
      <Icon aria-hidden />
    </button>
  );
});
